const URL = "https://api.astriddao.xyz/staking-incentives";

export async function fetchAtidStakingRewards(address: string): Promise<number | undefined> {
  if (!address) {
    return Promise.reject("User address is required to fetch staking rewards");
  }

  const response = await window.fetch(`${URL}?address=${address}`, {
    method: "GET",
    redirect: "follow"
  });

  if (!response.ok) {
    return Promise.reject(`${response.status} ${response.statusText}`);
  }

  if (response.status === 200) {
    return await response.json();
  } else if (response.status === 400) {
    return Promise.reject("Invalid address or address not provided.");
  } else if (response.status === 500) {
    return Promise.reject("Oops! Something went wrong!");
  }
}
